"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: 'app',
    computed: {
        currentChallengeType() {
            return this.$store.getters.currentChallengeType;
        },
    },
    watch: {
        currentChallengeType(currentChallengeType, previousChallengeType) {
            const event = new CustomEvent('challengetypechange', {
                bubbles: true,
                cancelable: false,
                detail: {
                    currentChallengeType,
                    previousChallengeType,
                },
            });
            this.$el.dispatchEvent(event);
        },
    },
});
